import React from 'react';
import RootContext from './RootContext';
const useRoot = () => {
    const rootCtx = React.useContext(RootContext);
    if (!rootCtx) {
        throw new Error('useRoot must be used inside of a <RootContext.Provider> component');
    }
    return rootCtx;
};
export default useRoot;
